import React, {useState} from "react"
import Box from "@amzn/meridian/box";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Input from "@amzn/meridian/input";
import SectionDetails from "./sectionDetails";

const CoinRemittanceSection = ({onRemittanceCodeChange, onConfirmRemittanceCodeChange}) => {
    const [remittanceCode, setRemittanceCode] = useState();
    const [confirmedRemittanceCode, setConfirmedRemittanceCode] = useState();

    const handleRemittanceCodeChange = event => {
        setRemittanceCode(event);
        onRemittanceCodeChange(event);
    }

    const handleConfirmedRemittanceCodeChange = event => {
        setConfirmedRemittanceCode(event);
        onConfirmRemittanceCodeChange(event);
    }

    return (
        <Box>
            <Row>
                <SectionDetails title="Deposit Code"
                                description="Enter the deposit code. Make sure the same deposit code is shared with the cash agent."/>
            </Row>
            <Column>
                <Row width="100%" widths="grid-8">
                    <Input
                        placeholder="Deposit Code"
                        size="xlarge"
                        value={remittanceCode}
                        onChange={handleRemittanceCodeChange}
                        error={remittanceCode === ""}
                    />
                </Row>
                <Row width="100%" widths="grid-8">
                    <Input
                        placeholder="Confirm Deposit Code"
                        size="xlarge"
                        value={confirmedRemittanceCode}
                        onChange={handleConfirmedRemittanceCodeChange}
                    />
                </Row>
            </Column>
        </Box>
    );
}

export default CoinRemittanceSection;



// WEBPACK FOOTER //
// ./src/component/modal/deposit/coinRemittanceSection.js